<template>
	<div class="data-table-container customize-table">
		<v3-table :headers="headers" :items="itemsToDisplay" alternating :rows-per-page="rowsPerPage" hide-rows-per-page
			hide-footer>
			<template #item-updatedAt="{ updatedAt }">
				{{ formatUpdatedAt(updatedAt) }}
			</template>
			<template #header-updatedAt="header">
				<div class="text-left cursor-pointer" @click="sortDate">
					{{ $t('date_and_time') }}
				</div>
			</template>
			<template #header-CustomerRequest="header">
				<div class="text-left cursor-pointer" @click="sortDate">
					{{ $t('demand_request') }}
				</div>
			</template>
			<template #header-pendingDay="header">
				<div class="text-left cursor-pointer" @click="sortDate">
					{{ $t('pending_day') }}
				</div>
			</template>
			<template #item-CustomerRequest="{ title }">
				{{ title }}
			</template>
			<template #item-sendToIncident="{ id, title, location, client }">
				<v-btn color="rgba(25, 118, 210, 1)" variant="text" class="text-none"
					@click="sendToIncidentFunction(id, title, location, client)">
					<span><v-icon color="">mdi-arrow-right-thin</v-icon>|
					</span>
					<div style="text-decoration: underline">{{ $t('incident_list') }}</div>
				</v-btn>
			</template>
			<template #item-pendingDay="{ updatedAt }">
				<v-chip class="text-white" :style="{ backgroundColor: getChipColor(updatedAt) }">
					{{ getChipText(updatedAt) }}
				</v-chip>
			</template>
			<template #item-button="{ id }">
				<div @click="this.$emit('delete', id)">
					<v-icon color="rgba(255, 126, 135, 1)">mdi-trash-can-outline</v-icon>
				</div>
			</template>
			<template #expand="{ client, location, clientCoupon }">
				<div>
					<div class="ml-10 mt-2">
						<v-row>
							<v-col cols="3">
								<div class="mt-2 font-weight-medium">
									{{ $t('location') }}
								</div>
							</v-col>
							<v-col cols="7">
								<div class="mt-2">{{ location }}</div>
							</v-col>
						</v-row>
					</div>

					<v-divider class="ma-4"> </v-divider>
					<div class="ml-10 mt-2 font-weight-medium">
						<v-row>
							<v-col cols="3">
								<div class="mt-2">{{ $t('customer') }}</div>
								<div class="mt-2">{{ $t('contact_number') }}</div>
								<div class="my-2">{{ $t('email') }}</div>
								<div class="my-2">
									{{ $t('role_list') }}</div>
							</v-col>
							<v-col cols="7">
								<div class="mt-2">{{ client.name }}</div>
								<div class="my-2">{{ client.phone }}</div>
								<div class="my-2">{{ client.email }}</div>
								<div class="my-2">
									<div v-if="clientCoupon" class="d-flex justify-center mb-4"
										style="flex-direction: column">
										<v-card rounded="xl" class="ma-2" style="
												background-color: rgba(
													255,
													126,
													135,
													0.1
												);
												width: 350px;
												display: flex;
												border: rgba(255, 126, 135, 1);
												cursor: pointer;
											">
											<v-row>
												<v-col cols="4">
													<div class="d-flex justify-center align-center h-100">
														<v-img src="/src/assets/img/prospace.png" height="60px"
															width="60px"></v-img>
													</div>
												</v-col>
												<v-col cols="8">
													<div class="my-2">
														<div style="
																font-size: 16px;
																font-weight: 700;
															">
															{{
																clientCoupon?.title
															}}
														</div>
														<div class="my-2" style="
																font-size: 16px;
																font-weight: 700;
																color: rgba(
																	153,
																	153,
																	153,
																	1
																);
															">
															{{
																clientCoupon?.couponCode
															}}
														</div>
														<div class="my-2" style="
																font-size: 16px;
																font-weight: 700;
																color: rgba(
																	153,
																	153,
																	153,
																	1
																);
															">
															ใช้ได้ก่อน
															{{
																formattedDate(
																	clientCoupon?.validUntil
																)
															}}
														</div>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</div>
									<div v-else>{{$t('no_coupon_found') }}</div>
								</div>
							</v-col>
						</v-row>
					</div>
				</div>
			</template>
		</v3-table>

		<div class="d-flex flex-row-reverse mx-10">
			<div class="d-flex">
				<div class="my-auto">{{ $t('rows_per_page') }}:</div>
				<v-select variant="underlined" :items="[10, 25, 50, 100]" style="max-width: 4.5rem" class="ml-8 my-auto"
					v-model="totalRowsPerPage" @update:model-value="onClick(totalRowsPerPage)"></v-select>
				<div class="my-auto ml-10">
					{{
						this.initialPage == 1
							? this.initialPage
							: (this.initialPage - 1) * this.totalRowsPerPage + 1
					}}
					- {{ this.initialPage * this.totalRowsPerPage }} of
					{{ this.totalIncidents }}
				</div>
				<div class="my-auto">
					<v-btn :disabled="initialPage == 1" variant="text" @click="previousPage">
						<v-icon size="30">mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn :disabled="items.length < this.totalRowsPerPage" variant="text" @click="nextPage">
						<v-icon size="30">mdi-chevron-right</v-icon>
					</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import settings from '@/services/API/settings'
import incidentService from '@/services/API/incidentService'
import moment from 'moment'

export default {
	async created() {
		await settings.getDefaultPageValue().then((response) => {
			this.totalRowsPerPage = response.data.pageSize
		})
	},
	name: 'DataTable',
	components: {
		'v3-table': Vue3EasyDataTable,
	},
	emits: [
		'totalRowsPerPage',
		'pageNumber',
		'delete',
		'delete-without-confirm',
	],
	props: {
		headers: Array,
		items: Array,
		rowsPerPage: {
			type: Number,
			default: 100,
		},
	},

	data: () => ({
		isDeletePopupOpen: false,
		currentPage: 1,
		initialPage: 1,
		initialRowsPerPage: '10',
		totalIncidents: '100',
	}),
	methods: {
		formattedDate(validUntil) {
			return moment(validUntil).format('DD-MM-yyyy')
		},
		sendToIncidentFunction(id, title, location, client) {
			// this.$router.push(
			// 	`/create-incident?demand_id=${id}&demand_title=${title}&demand_location=${location}&demand_client_phone=${client?.phone}&demand_client_name=${client?.name}&demand_client_email=${client?.email}`
			// )
			incidentService
				.createNewIncident(
					{
						title: title,
						name: client?.name,
						email: client?.email,
						phone: client?.phone,
						skills: [],
						note: null,
						relatedIncidentId: [],
						priority: 'low',
						jobs: [
							{
								description: title,
								address: location,
								dueDate: new Date().toString(),
								workingPeriod: null,
								wages: null,
							},
						],
					},
					{}
				)
				.then((res) => {
					if (res.status === 200) {
						this.$emit('delete-without-confirm', id)
					}
				})
		},
		formatUpdatedAt(updatedAt) {
			const date = new Date(updatedAt)
			const year = date.getFullYear()
			const month = String(date.getMonth() + 1).padStart(2, '0')
			const day = String(date.getDate()).padStart(2, '0')
			const hours = String(date.getHours()).padStart(2, '0')
			const minutes = String(date.getMinutes()).padStart(2, '0')

			return `${year}/${month}/${day} ${hours}:${minutes}`
		},
		getChipColor(updatedAt) {
			const daysDiff = this.calculateDays(updatedAt)

			if (daysDiff === 0) {
				return 'grey'
			} else if (daysDiff === 1) {
				return 'rgba(251, 200, 22, 1)'
			} else if (daysDiff === 2) {
				return 'rgba(251, 132, 22, 1)'
			} else {
				return 'rgba(255, 35, 49, 1)'
			}
		},

		getChipText(updatedAt) {
			const daysDiff = this.calculateDays(updatedAt)

			return daysDiff === 1 || daysDiff === 0
				? `${daysDiff} day`
				: `${daysDiff} days`
		},

		calculateDays(updatedAt) {
			const updatedDate = new Date(updatedAt)
			const now = new Date()

			// Calculate the difference in time in milliseconds
			const timeDiff = now - updatedDate

			// Calculate the difference in full days
			const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24))

			// Check if less than 24 hours have passed
			if (timeDiff < 1000 * 60 * 60 * 24) {
				return 0
			}

			return daysDiff
		},
		openDeletePopup(id) {
			this.isDeletePopupOpen = true
		},
		previousPage() {
			this.initialPage -= 1
			this.$emit('pageNumber', this.initialPage)
		},
		nextPage() {
			this.initialPage += 1
			this.$emit('pageNumber', this.initialPage)
		},
		onClick(length) {
			this.$emit('totalRowsPerPage', length)
		},
		updateCurrentPage(page) {
			this.currentPage = page
		},
	},
	computed: {
		itemsToDisplay() {
			// Reverse the array to display the latest items at the top
			const reversedItems = [...this.items].reverse()

			const startIndex = (this.currentPage - 1) * this.rowsPerPage
			const endIndex = startIndex + this.rowsPerPage

			// Slice the reversed array
			return reversedItems.slice(startIndex, endIndex)
		},
	},
}
</script>
<style scoped>
.customize-table {
	--easy-table-border: 1px solid var(--primary-color-lighten);
	--easy-table-row-border: 1px solid var(--primary-color-lighten);
	--easy-table-header-font-size: 18px;
	--easy-table-header-height: 50px;
	--easy-table-header-background-color: var(--secondary-color);
	--easy-table-header-item-padding: 15px 20px;
	/* --easy-table-header-font-color: white; */

	--easy-table-body-row-background-color: var(--secondary-color-lighten);
	--easy-table-body-row-height: 50px;
	--easy-table-body-row-font-size: 16px;
	--easy-table-body-row-hover-background-color: var(--primary-color-lighten);

	--easy-table-body-item-padding: 10px 15px;
	--easy-table-footer-background-color: var(--gray-1);
	--easy-table-footer-font-size: 14px;
	--easy-table-footer-padding: 0px 10px;
	--easy-table-footer-height: 50px;

	--easy-table-loading-mask-background-color: #000000;
	font-family: 'Roboto';
}
</style>
